import { render, staticRenderFns } from "./download-icon.vue?vue&type=template&id=5227e34a"
import script from "./download-icon.vue?vue&type=script&lang=js"
export * from "./download-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports